
import {
  FETCH_ACCOUNTS,
  FETCH_ACCOUNTS_ERROR,
  FETCHED_ACCOUNTS,
  UPDATE_ACCOUNTS,
  UPDATE_ACCOUNTS_ERROR,
  UPDATED_ACCOUNTS
} from 'actions'

export default function (state = {}, { type, payload }) {
  switch (type) {
    case FETCH_ACCOUNTS:
      return {
        ...state,
        [`fetch-${payload.workspaceSlug}-${payload.sourceSlug}`]: {
          isRequesting: true,
          didRequestFail: false,
          data: {}
        }
      }
    case FETCH_ACCOUNTS_ERROR:
      return {
        ...state,
        [`fetch-${payload.workspaceSlug}-${payload.sourceSlug}`]: {
          isRequesting: false,
          didRequestFail: true,
          data: payload
        }
      }
    case FETCHED_ACCOUNTS:
      return {
        ...state,
        [`fetch-${payload.workspaceSlug}-${payload.sourceSlug}`]: {
          isRequesting: false,
          didRequestFail: false,
          data: payload.response
        }
      }
  // Update and Fetch do not return the same object. Fetch returns options. Update is your choice.
    case UPDATE_ACCOUNTS:
      return {
        ...state,
        [`update-${payload.workspaceSlug}-${payload.sourceSlug}`]: {
          isRequesting: true,
          didRequestFail: false,
          data: {}
        }
      }
    case UPDATE_ACCOUNTS_ERROR:
      return {
        ...state,
        [`update-${payload.workspaceSlug}-${payload.sourceSlug}`]: {
          isRequesting: false,
          didRequestFail: true,
          data: payload.response
        }
      }
    case UPDATED_ACCOUNTS:
      return {
        ...state,
        [`update-${payload.workspaceSlug}-${payload.sourceSlug}`]: {
          isRequesting: false,
          didRequestFail: false,
          data: payload.response
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/accounts.js